import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getProductoBySlug } from "./services";
import { Container, Button, Row, Col, Card } from "react-bootstrap";
import ProductosDestacados from './ProductosDestacados'
import { formatPrice } from "../utils/formatPrice";
import SEO from "../SEO/SEO";
import "./DetalleProducto.css";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://whiskyandco.com.ar";

const DetalleProducto = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [producto, setProducto] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const cargarProducto = async () => {
            try {
                const response = await getProductoBySlug(slug);
                if (response.status === 200) {
                    setProducto(response.data.producto);
                } else {
                    setError("No se pudo cargar el producto.");
                }
            } catch (err) {
                setError("Ocurrió un error al intentar cargar el producto.");
            }
        };
        cargarProducto();
    }, [slug]);

    if (error) {
        return <div className="text-danger text-center mt-5">{error}</div>;
    }

    if (!producto) {
        return <div className="text-center mt-5">Cargando producto...</div>;
    }

    const canonicalPath = `/productos/${producto.slug || slug}`;
    const currentPrice = producto.enPromocion && producto.precioPromocion
        ? Number(producto.precioPromocion)
        : Number(producto.precio);

    const productDescription = producto.descripcion
        ? producto.descripcion
        : `${producto.nombre}. ${producto.categoria?.nombre || "Sin categoria"}. ${producto.tipoWhisky || "Whisky"}.`;

    const detailStructuredData = [
        {
            "@context": "https://schema.org",
            "@type": "Product",
            name: producto.nombre,
            ...(producto.descripcion ? { description: producto.descripcion } : {}),
            ...(producto.imagen ? { image: [producto.imagen] } : {}),
            ...(producto.categoria?.nombre ? { category: producto.categoria.nombre } : {}),
            brand: {
                "@type": "Brand",
                name: "Whisky&Co"
            },
            offers: {
                "@type": "Offer",
                url: `${SITE_URL}${canonicalPath}`,
                priceCurrency: "ARS",
                price: Number.isFinite(currentPrice) ? currentPrice : undefined
            }
        },
        {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
                {
                    "@type": "ListItem",
                    position: 1,
                    name: "Inicio",
                    item: `${SITE_URL}/`
                },
                {
                    "@type": "ListItem",
                    position: 2,
                    name: "Productos",
                    item: `${SITE_URL}/productos`
                },
                {
                    "@type": "ListItem",
                    position: 3,
                    name: producto.nombre,
                    item: `${SITE_URL}${canonicalPath}`
                }
            ]
        }
    ];

    const handleConsultarProducto = () => {
        const mensaje = `Hola, quiero consultar por el whisky ${producto.nombre}.`;
        const urlWhatsApp = `https://wa.me/5493515295096?text=${encodeURIComponent(mensaje)}`;
        window.open(urlWhatsApp, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="detalle-producto-container">
            <SEO
                title={`${producto.nombre} | Whisky And Co`}
                description={productDescription}
                canonicalPath={canonicalPath}
                type="product"
                image={producto.imagen}
                structuredData={detailStructuredData}
            />

            <Container className="py-4">
                <Row className="detalle-producto-card ">

                    {/* 🔥 Imagen del producto */}
                    <Col md={4} className="detalle-imagen">
                        <Card className="position-relative">
                            {producto.enPromocion && (
                                <div className="cartel-promocion">🔥 En promoción</div>
                            )}
                            <Card.Img variant="top" src={producto.imagen} alt={producto.nombre} />
                        </Card>
                    </Col>


                    {/* 🔥 Información del producto */}
                    <Col md={5} className="detalle-info">
                        <h1>{producto.nombre}</h1>
                        {producto.enPromocion ? (
                            <div className="precio-promo-container">
                                <p className="precio-tachado">Precio lista: {formatPrice(producto.precio)}</p>
                                <p className="precio-promocion">Precio promo: {formatPrice(producto.precioPromocion)}</p>
                            </div>
                        ) : (
                            <p className="precioDetalle"><strong>Precio:</strong> {formatPrice(producto.precio)}</p>
                        )}

                        <p><strong>Categoría:</strong> {producto.categoria?.nombre || "Sin categoría"}</p>

                        <p><strong>Tipo Whisky:</strong> {producto.tipoWhisky}</p>

                        {producto.descripcion && (
                            <p><strong>Descripcion:</strong> {producto.descripcion}</p>
                        )}
                    </Col>

                    {/* 🔥 Botones de acción */}
                    <Col md={12} lg={3} className="detalle-botones">
                        <div className="detalle-botones-contenedor">
                            <div className="d-flex flex-column botonesDeAccionDetalle ">

                                <Button
                                    variant="primary"
                                    onClick={handleConsultarProducto}
                                    className="comprar"
                                >
                                    Consultar producto
                                </Button>

                                <Button variant="secondary" onClick={() => navigate(-1)}>
                                    Volver
                                </Button>
                            </div>

                        </div>
                    </Col>


                </Row>
            </Container>
            <ProductosDestacados />
        </div>
    );
};

export default DetalleProducto;
